import { render, staticRenderFns } from "./EmojiSelector.vue?vue&type=template&id=091ca4d2&scoped=true&"
import script from "./EmojiSelector.vue?vue&type=script&lang=js&"
export * from "./EmojiSelector.vue?vue&type=script&lang=js&"
import style0 from "./EmojiSelector.vue?vue&type=style&index=0&id=091ca4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091ca4d2",
  null
  
)

export default component.exports